import { IClassname } from '@/lib/shared/model/classname';

export const Maiden = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2483 6.62492C23.4892 6.01654 23.5301 5.34722 23.3648 4.71408C23.1995 4.08095 22.8368 3.51693 22.3293 3.10387C21.8219 2.6908 21.196 2.4502 20.5424 2.41695C19.8889 2.3837 19.2419 2.55955 18.6951 2.91896C18.4339 2.43145 18.0454 2.02392 17.5709 1.73982C17.0964 1.45571 16.5537 1.30566 16.0006 1.30566C15.4475 1.30566 14.9048 1.45571 14.4303 1.73982C13.9558 2.02392 13.5673 2.43145 13.3061 2.91896C12.7593 2.55955 12.1122 2.3837 11.4587 2.41695C10.8052 2.4502 10.1793 2.6908 9.6718 3.10387C9.1643 3.51693 8.80163 4.08095 8.63639 4.71408C8.47116 5.34722 8.51195 6.01654 8.75288 6.62492L9.17331 7.81211C11.1104 6.28372 13.5355 5.50878 15.9999 5.6307C18.4644 5.50878 20.8895 6.28372 22.8266 7.81211L23.2483 6.62492Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.187 30.0344V25.6895L21.0708 27.8376C20.6493 28.2662 20.0872 28.5281 19.4879 28.5751C18.8887 28.622 18.2926 28.4509 17.8095 28.0932L16 26.754"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.81299 30.0344V25.6895L10.9292 27.8376C11.3507 28.2662 11.9128 28.5281 12.5121 28.5751C13.1113 28.622 13.7074 28.4509 14.1904 28.0932L16 26.754"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0637 24.1172C19.7648 24.9385 19.2064 25.6401 18.4732 26.1157C17.74 26.5915 16.8717 26.8154 15.9999 26.7535C15.1309 26.8144 14.2656 26.592 13.5336 26.1197C12.8017 25.6474 12.2425 24.9506 11.9399 24.1338"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8709 17.2871C17.3311 17.6918 16.6746 17.9107 16 17.9107C15.3254 17.9107 14.6689 17.6918 14.1292 17.2871"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4979 14.4808C13.3215 14.4808 13.1785 14.3378 13.1785 14.1613C13.1785 13.9849 13.3215 13.8418 13.4979 13.8418"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M13.4978 14.4808C13.6743 14.4808 13.8173 14.3378 13.8173 14.1613C13.8173 13.9849 13.6743 13.8418 13.4978 13.8418"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M18.3629 14.4808C18.1865 14.4808 18.0435 14.3378 18.0435 14.1613C18.0435 13.9849 18.1865 13.8418 18.3629 13.8418"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M18.3628 14.4808C18.5393 14.4808 18.6823 14.3378 18.6823 14.1613C18.6823 13.9849 18.5393 13.8418 18.3628 13.8418"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M21.6125 12.2939C20.4416 12.2947 19.2942 11.9657 18.3016 11.3446C17.309 10.7235 16.5113 9.83552 15.9999 8.78223C15.4885 9.83552 14.6908 10.7235 13.6982 11.3446C12.7056 11.9657 11.5582 12.2947 10.3873 12.2939C10.1764 12.2939 9.96942 12.2837 9.76367 12.2633V15.4121C9.76367 17.066 10.4207 18.6523 11.5902 19.8217C12.7597 20.9913 14.3459 21.6484 15.9999 21.6484C17.6539 21.6484 19.2401 20.9913 20.4096 19.8217C21.5792 18.6523 22.2361 17.066 22.2361 15.4121V12.2671C22.0304 12.2939 21.8234 12.2939 21.6125 12.2939Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09166 7.58203C7.81971 9.06087 7.167 10.9732 7.26935 12.9212V15.9997C7.26917 18.544 6.35798 21.0043 4.70074 22.9349C4.63906 23.007 4.59459 23.0921 4.5707 23.1839C4.5468 23.2756 4.54411 23.3717 4.56282 23.4646C4.58154 23.5577 4.62119 23.6451 4.67873 23.7205C4.73628 23.7959 4.81023 23.8572 4.89498 23.8998L8.60094 25.8537"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3979 25.8486L27.1038 23.8946C27.1886 23.8521 27.2626 23.7908 27.3201 23.7154C27.3777 23.64 27.4173 23.5526 27.436 23.4595C27.4548 23.3666 27.4521 23.2705 27.4282 23.1788C27.4043 23.087 27.3598 23.0019 27.2981 22.9298C25.6424 21.0003 24.7318 18.5421 24.7308 15.9997V12.9212C24.8326 10.9733 24.18 9.06114 22.9084 7.58203"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.436 30.6958C26.4115 28.5289 24.7926 26.6978 22.7677 25.4154C20.7429 24.133 18.3954 23.4521 15.9986 23.4521C13.6019 23.4521 11.2544 24.133 9.22954 25.4154C7.20469 26.6978 5.58577 28.5289 4.56128 30.6958"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
